import { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import MetasServicoFiltros from '../../components/MetasServicoFiltros/MetasServicoFiltros';
import MetasServicoCadastro from '../../components/MetasServicoCadastro/MetasServicoCadastro';
import NotifierPopup from '../../components/NotifierPopup/NotifierPopup';

export default function MetasServicoAdm() {
    
    const methods = useForm();
    const { setValue, reset } = methods;

    const [ notify, setNotify ] = useState({
        isActive: false,
        isSuccessful: undefined,
        message: undefined
    });

    const [ modoInsercao, setModoInsercao ] = useState('percentual');

    const retornarStateFormatado = (state) => {
        const [ value, setValue ] = state;

        return {
            value: value,
            setValue: setValue
        }
    }
    const filtros = {
        mes:        retornarStateFormatado(useState(null)),
        ano:        retornarStateFormatado(useState(new Date().getFullYear())),
        cluster:    retornarStateFormatado(useState(null)),
        regiao:     retornarStateFormatado(useState(null)),
        filial:     retornarStateFormatado(useState(null))
    }

    //Utilitarios
    const limparFiltros = () => {
        filtros.mes.setValue(null);
        filtros.ano.setValue(new Date().getFullYear());
        filtros.cluster.setValue(null);
        filtros.regiao.setValue(null);
        filtros.filial.setValue(null);
    }

    function isArrayVazio(array) {
        return !Array.isArray(array) || array === null || array.length === 0;
    }

    const isSegundaEtapaDesabilitada = (
        cluster = filtros.cluster.value, 
        regiao = filtros.regiao.value, 
        filial = filtros.filial.value, 
        mes = filtros.mes.value?.value, 
        ano = filtros.ano.value
    ) => {
        return ((
                isArrayVazio(cluster)   &&
                isArrayVazio(regiao)    &&
                isArrayVazio(filial)
            ) ||
            mes === null ||
            typeof mes === 'undefined' ||
            ano === null
        );
    }

    //Actions
    const handleSetMetas = (metas) => {
        metas.forEach(meta => {
            setValue(`${meta.idtiposervico}.${meta.tipo_percentual ? 'percentual' : 'absoluto'}`, meta.valor);
        });
    }

    return <>
        {notify.isActive && 
            <NotifierPopup 
                notify={notify}
                setNotify={setNotify}
            />
        }
        <MetasServicoFiltros
            filtros={filtros}
            setMetasValue={handleSetMetas}
            resetForm={reset}
            isSegundaEtapaDesabilitada={isSegundaEtapaDesabilitada}
            setModoInsercao={setModoInsercao}
        />
        <FormProvider {... methods}>
            <MetasServicoCadastro
                modoInsercao={modoInsercao}
                setModoInsercao={setModoInsercao}
                filtrosValue={{
                    cluster: filtros.cluster.value,
                    regiao: filtros.regiao.value,
                    filial: filtros.filial.value,
                    
                    mes: filtros.mes.value,
                    ano: filtros.ano.value
                }}
                limparFiltros={limparFiltros}
                setNotifier = {(isSuccess, message) => setNotify({
                    isActive: true,
                    isSuccessful: isSuccess,
                    message: message
                })} 
                methods={methods} 
                isArrayVazio={isArrayVazio}
                isSegundaEtapaDesabilitada={isSegundaEtapaDesabilitada}
            />
        </FormProvider>
    </>
}